export enum RTSystemTileSelectionType {
  multiSelect = 'multiSelect',
  singleSelect = 'singleSelect',
}
